import { Box, Button, Typography } from "@mui/material"

function GetStart({ handleNext }) {
  return (
    <>
      <Typography
        mb={2}
        variant="displayLarge"
        color="other.color1"
      >Let's Build Your Personalized Wellness Path
      </Typography>
      <Typography
        mb={5}
        textAlign="center"
        variant="bodyLead"
        color="other.color2"
      >Answer a few quick questions and we'll guide you to the right support for your mind, body, and lifestyle.
      </Typography>
      <Box textAlign="center">
        <Button
          sx={{
            px: { md: 4 },
            fontSize: "18px",
            minWidth: "100px",
            borderRadius: "50px",
            justifyContent: "center"
          }}
          size="small"
          color="primary"
          variant="contained"
          onClick={handleNext}
        >Let's Get Started
        </Button>
      </Box>
    </>
  )
}

export default GetStart